export class CompletionNumberLabel {
    ID: number;
    Name: string;
    Inactive?: boolean;
}

export default CompletionNumberLabel;